<template>
  <div>
    <div>
      <router-link to="/">Home</router-link>
      <label class="labelBar"> / </label>
      <label> Cadastro/Manutenção/Chamado Manutenção</label>
    </div>
    <v-container fluid
      ><v-row align="center">
        <v-col cols="12" sm="2">
          <v-btn
            color="info"
            to="/chamadoManutencao/criar"
            v-if="isAllowed(idModulo)"
            class="ma-2 white--text"
          >
            NOVO
          </v-btn>
        </v-col>
        
        <v-col cols="12" sm="8">
          <v-radio-group v-model="selectedFilter" row>
            <v-radio value="0">
              <template v-slot:label>
                <v-avatar size="25" color="primary">
                  <span class="white--text text-h6">TD</span>
                </v-avatar>
                <div class="ma-1 text-h5">Todas</div>
              </template></v-radio
            ><v-radio value="EA">
              <template v-slot:label>
                <v-avatar size="25" color="red">
                  <span class="white--text text-h6">EA</span>
                </v-avatar>
                <div class="ma-1 text-h5">Em Aberto</div>
              </template>
            </v-radio>
            <v-radio value="OG">
              <template v-slot:label>
                <v-avatar color="green" size="25">
                  <span class="white--text text-h6">OG</span>
                </v-avatar>
                <div class="ma-1 text-h5">Ordem Serviço Gerada</div>
              </template>
            </v-radio>
            <v-radio value="B">
              <template v-slot:label>
                <v-avatar color="grey darken-1" size="25">
                  <span class="white--text text-h6">B</span>
                </v-avatar>
                <div class="ma-1 text-h5">Baixado</div>
              </template>
            </v-radio>
            <v-radio value="I">
              <template v-slot:label>
                <v-avatar color="grey darken-1" size="25">
                  <span class="white--text text-h6">I</span>
                </v-avatar>
                <div class="ma-1 text-h5">Inativa</div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>
        <v-col class="text-right" cols="12" sm="2">
          <v-btn
            @click="baixarlista()"
            v-if="chamadosManutencao.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="right">
        <v-col cols="12" sm="6" md="3" class="text-left">
          <v-menu
            v-model="menuData1"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="computedDataIni"
                label="Data inicio"
                prepend-icon="mdi-calendar"
                v-mask="['##/##/####']"
                maxlength="10"
                v-bind="attrs"
                v-on="on"
                @input="onInputDate1"
                @click:clear="dataIni = null"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dataIni"
              @input="menuData1 = false"
              @change="dateChangeDataIni"
              :max="new Date().toISOString().substr(0, 10)"
              locale="pt-br"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="text-left">
          <v-menu
            v-model="menuData2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedDataFim"
                label="Data fim"
                prepend-icon="mdi-calendar"
                v-mask="['##/##/####']"
                maxlength="10"
                v-bind="attrs"
                v-on="on"
                @input="onInputDate2"
                @click:clear="dataFim = null"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dataFim"
              @input="menuData2 = false"
              @change="dateChangeDataFim"
              locale="pt-br"
              forma
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        :loading="loading"
        loading-text="Buscando dados..."
        :search="search"
        :options.sync="options"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
      >
      <template v-slot:item.status="{ item }">
          <v-avatar v-if="item.status == 'EA'" color="red" size="24">
            <span class="white--text text-h5">EA</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'OG'" color="green" size="24">
            <span class="white--text text-h5">OG</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'B'" color="grey darken-1" size="24">
            <span class="white--text text-h5">B</span>
          </v-avatar>
          <v-avatar
            v-else-if="item.status == 'D'"
            color="grey darken-1"
            size="24"
          >
            <span class="white--text text-h5">D</span>
          </v-avatar>
          <v-avatar v-else color="blue-grey lighten-4" size="24">
            <span class="white--text text-h5">I</span>
          </v-avatar>
        </template>
        <template v-slot:item.id="{ item }">
          <span v-if="item.id && item.id !== 0">
            <a
              href="#"
              @click.prevent="abrirModal(item)"
              class="text--primary font-weight-medium text-decoration-underline"
            >
              {{ item.id }}
            </a>
          </span>
          <span v-else>—</span>
        </template>
        <template v-slot:item.ativo="{ item }">
          {{ item.ativo ? "Ativo" : "Inativo" }}
        </template>

        <template v-slot:item.dataCadastro="{ item }">
          <span>{{
            item.dataCadastro == null ? "" : new Date(item.dataCadastro)
              .toLocaleString()
              .replace(/(.*)\D\d+/, "$1")
          }}</span>
        </template>
        <template v-slot:item.dataFinal="{ item }">
          <span>{{
            item.dataFinal == null ? "" : new Date(item.dataFinal).toLocaleString().replace(/(.*)\D\d+/, "$1")
          }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editar(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span v-if="isAllowed(idModulo)">Editar</span>
            <span v-else>Ver</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog
      style="z-index: 9999"
      v-model="showModal"
      persistent
      max-width="1000px"
      ><v-card>
        <v-card-title>
          <span class="headline">Chamado Nº {{ id }} - Equipamento: {{ equipamento }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form2" v-model="validFrm2" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    label="Chamado"
                    v-model="descricao"
                    clear-icon="mdi-close-circle"
                    readonly
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    label="Justificativa"
                    v-model="justificativa"
                    readonly
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    label="Baixado Por"
                    v-model="finalizador"
                    clear-icon="mdi-close-circle"
                    readonly
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
            <v-row align="center-left">
              <v-col class="text-right">
                <v-btn @click="showModal = false" color="info" class="mr-4">
                  fechar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { downloadLista } from "../../../services/chamadoManutencaoService";
import { getUserRoles } from "@/services/loginService";
import moment from "moment";
import { saveAs } from "file-saver";

export default {
  name: "listaChamadosManutencao",
  data() {
    return {
      idModulo: 18,
      loading: false,
      selectedFilter: "0",
      search: "",
      showAtivo: false,
      active_tab: 2,
      id: null,
      equipamento: null,
      justificativa: null,
      descricao: null,
      showModal: false,
      dataIni: null,
      dataFim: null,
      menuData1: false,
      menuData2: false,
      headers: [
        {
          text: "Chamado",
          align: "start",
          value: "id",
        },
        { text: "Data", value: "dataCadastro" },
        { text: "Data Final", value: "dataFinal" },
        { text: "Tempo Chamado", value: "tempo" },
        { text: "Criado Por", value: "usuario" },
        { text: "Baixado Por", value: "finalizador" },
        { text: "Unidade Adm", value: "unidadeAdm" },
        { text: "Equipamento", value: "equipamento" },
        { text: "Status", value: "status" },
        { text: "Ações", value: "actions", sortable: false },
      ],
      filters: {
        dataCadastro: [],
        dataFinal: [],
        usuario: [],
        finalizador: [],
        equipamento: [],
      },
    };
  },
  computed: {
    ...mapState("chamadoManutencao", ["chamadosManutencao"]),
    filteredList() {
      const searchLower = this.search.toLowerCase();

      return this.chamadosManutencao
        .filter((cm) => {
          // 1. Filtro por texto digitado
          const buscaTexto =
            cm.id.toString().toLowerCase().includes(searchLower) ||
            cm.unidadeAdm.toLowerCase().includes(searchLower) ||
            cm.usuario.toLowerCase().includes(searchLower) ||
            cm.equipamento.toLowerCase().includes(searchLower) 

          // 2. Filtro por data (se datas forem preenchidas)
          const dataValida =
            !this.dataIni ||
            !this.dataFim ||
            (new Date(cm.dataCadastro.split("T")[0]) >=
              new Date(this.dataIni.split("T")[0]) &&
              (cm.dataFinal ? new Date(cm.dataFinal.split("T")[0]) <=
                new Date(this.dataFim.split("T")[0]) : new Date(cm.dataCadastro.split("T")[0]) <=
                new Date(this.dataFim.split("T")[0])));

          // 3. Filtros refinados (filters)
          const filtrosOk = Object.keys(this.filters).every((f) => {
            if (this.filters[f].length < 1) return true;

            if (f === "data") {
              const dataFormatada = new Date(cm[f])
                .toLocaleString()
                .replace(/(.*)\D\d+/, "$1");
              return this.filters[f].includes(dataFormatada);
            }

            return this.filters[f].includes(r[f]);
          });

          // 4. Filtro por status (se não for "0")
          const statusOk =
            this.selectedFilter === "0" || cm.status === this.selectedFilter;

          return buscaTexto && dataValida && filtrosOk && statusOk;
        })
        .sort((a, b) => b.id - a.id);
    },
    computedDataIni() {
      return this.dataIni ? moment(this.dataIni).format("DD/MM/YYYY") : null;
    },
    computedDataFim() {
      return this.dataFim ? moment(this.dataFim).format("DD/MM/YYYY") : null;
    },
  },
  methods: {
    ...mapActions("chamadoManutencao", [
      "atualizarChamadosManutencao",
      "atualizarChamadoManutencao",
    ]),
    ...mapActions("local", ["atualizarLocais"]),
    ...mapActions("equipamento", ["atualizarEquipamentos"]),
    editar(chamadoManutencao) {
      this.atualizarChamadoManutencao(chamadoManutencao);
      if (this.isAllowed(this.idModulo)) {
        this.$router.push({
          path: "/chamadoManutencao/editar",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
      } else {
        this.$router.push({
          path: "/chamadoManutencao/ver",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
      }
    },
    baixarlista() {
      const blob = this.gerarExcel();
      const nome_arquivo = "chamadosManutencao.xlsx";
      saveAs(blob, nome_arquivo);
    },
    async obterLista() {
      this.loading = true;
      await this.atualizarChamadosManutencao();
      this.loading = false;
    },
    isAllowed(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.escrita;
    },
    columnValueList(val) {
      return this.filteredList.map((d) => d[val]);
    },
    doAjax() {
      if (!this.locais || this.locais.length == 0) {
        this.atualizarLocais();
      }
      if (!this.equipamentos || this.equipamentos.length == 0) {
        this.atualizarEquipamentos();
      }
    },
    abrirModal(chamado){
      this.id = chamado.id;
      this.descricao = chamado.descricao;
      this.justificativa = chamado.justificativa;
      this.equipamento = chamado.equipamento;
      this.finalizador = chamado.finalizador;

      this.showModal = true;
    },
    
    onInputDate1(val) {
      if (val.length == 10) {
        const newDate = moment(val, "DD/MM/YYYY");
        if (newDate.isValid() && newDate <= new Date()) {
          this.dataIni = moment(val, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataIni(date) {
      this.dataIni = date;
    },
    onInputDate2(val) {
      if (val.length == 10) {
        const newDate = moment(val, "DD/MM/YYYY");
        if (newDate.isValid()) {
          this.dataFim = moment(val, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataFim(date) {
      this.dataFim = date;
    },
    gerarExcel() {
      const colunas = [
        { chave: "id", cabecalho: "Chamado" },
        { chave: "data", cabecalho: "Data" },
        { chave: "dataFinal", cabecalho: "Data Final" },
        { chave: "tempo", cabecalho: "Tempo Chamado" },
        { chave: "usuario", cabecalho: "Criado por" },
        { chave: "finalizador", cabecalho: "Baixado Por" },
        { chave: "unidadeAdm", cabecalho: "Unidade Adm" },
        { chave: "equipamento", cabecalho: "Equipamento" },
        { chave: "status", cabecalho: "Status" },
      ];

      const aoa = [];

      aoa.push(colunas.map((c) => c.cabecalho));

      this.filteredList.forEach((item) => {
        aoa.push(
          colunas.map((c) => {
            if (c.chave === "data" || c.chave === "dataFinal") {
              return new Date(item[c.chave])
                .toLocaleString()
                .replace(/(.*)\D\d+/, "$1");
            } else if (c.chave === "id") {
              return item[c.chave] === 0 ? "" : item[c.chave];
            } else {
              return item[c.chave];
            }
          })
        );
      });

      const ws = window.XLSX.utils.aoa_to_sheet(aoa);

      const larguras = colunas.map((col, i) => {
        const valores = [
          col.cabecalho,
          ...this.filteredList.map((d) => String(d[col.chave])),
        ];
        const larguraMaxima = Math.max(...valores.map((v) => v.length)) + 2;
        return { wch: larguraMaxima };
      });
      ws["!cols"] = larguras;

      const headerStyle = {
        font: { bold: true },
        alignment: { horizontal: "center" },
      };
      colunas.forEach((col, index) => {
        const colLetra = String.fromCharCode(65 + index); // A, B, C...
        const cell = ws[`${colLetra}1`];
        if (cell) cell.s = headerStyle;
      });
      const wb = window.XLSX.utils.book_new();
      window.XLSX.utils.book_append_sheet(wb, ws, "Planilha");

      const wbout = window.XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
        cellStyles: true,
      });

      return new Blob([wbout], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
    },
  },
  watch: {
    "options.page"(p) {
      this.$router.replace({
        query: { ...this.$route.query, page: String(p) },
      });
    },
    "$route.query.page": {
      immediate: true,
      handler(val) {
        const qPage = parseInt(val, 10);
        const next = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
        if (next !== this.options.page) {
          this.options = { ...this.options, page: next };
        }
      },
    },
  },
  created: function () {
    const f = this.$route.query.selectedFilter;
    const allowed = ['0', 'EA', 'OG', 'B', 'I'];
    this.selectedFilter = allowed.includes(f) ? f : '0';
    this.obterLista();
    this.doAjax();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }

    const qPage = parseInt(this.$route.query.page, 10);
    this.options.page = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
  },
};
</script>
